import { em, math } from 'polished'
import styled from 'styled-components'

const heightByLayout = ({ layout }) => {
  if (layout === 'genom') return em(570)
  if (layout === 'bundle') return em(570)
  if (layout === 'promo') return em(580)
  return em(498)
}

const heightMdByLayout = ({ layout }) => {
  if (layout === 'genom') return em(830)
  return em(830)
}

const heightLgByLayout = ({ layout }) => {
  if (layout === 'genom') return em(666)
  return em(666)
}

export const Container = styled.div`
  box-sizing: content-box;
  height: ${heightByLayout};
  padding-top: ${p => p.theme.blocks.menuHeight};
  transition: color ease 150ms;

  ${p => p.theme.mq.upMd} {
    height: ${heightMdByLayout};
    padding-top: ${({ theme, hasSalesBanner, indentHeight }) =>
      hasSalesBanner
        ? math(
          `${theme.blocks.menuHeightMd} + ${
            indentHeight?.md ? em(indentHeight.md) : theme.blocks.menuHeightMd
          }`,
        )
        : math(`${theme.blocks.menuHeightMd}`)};
  }

  ${p => p.theme.mq.upLg} {
    height: ${heightLgByLayout};
    padding-top: ${({ theme, hasSalesBanner, indentHeight }) =>
      hasSalesBanner
        ? math(
          `${theme.blocks.menuHeightMd} + ${
            indentHeight?.lg ? em(indentHeight.lg) : theme.blocks.menuHeightMd
          }`,
        )
        : math(`${theme.blocks.menuHeightMd}`)};
  }

  .swiper-container {
    height: 100%;
  }
`

export const Wrapper = styled.div`
  position: relative;
  height: 100%;
  width: 100%;
`

export const PaginationBox = styled.div`
  position: absolute;
  z-index: 11;
  bottom: ${em(20)};
  left: 50%;
  transform: translateX(-50%);

  ${p => p.theme.mq.upMd} {
    bottom: ${em(41)};
  }

  ${p => p.theme.mq.upLg} {
    transform: translateX(0);
    bottom: ${em(60)};
    left: ${p => p.theme.indents.baseBoxIndentLg};
  }
`
